import { ReactNode, useState } from 'react';
import { observer } from 'mobx-react-lite';

import { NotificationsProvider, NotificationsStore } from '../notifications';

export { useNotify } from '../notifications';
export { useNotify as usePageNotify } from '../notifications';

type PageNotificationsProviderProps = {
  children: ReactNode | ReactNode[];
};

export const PageNotificationsProvider = observer(
  ({ children }: PageNotificationsProviderProps) => {
    const [notifyStore] = useState(() => new NotificationsStore());

    return (
      <NotificationsProvider value={notifyStore}>
        {children}
      </NotificationsProvider>
    );
  }
);
